import React,{Component} from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
//import images
import banner1 from "views/job-details/img/business/business1.png";
import banner2 from "views/job-details/img/business/business2.png";
import playbutton from "views/job-details/img/business/play-button.png";
import check from "views/job-details/img/business/check.png";
// install Swiper modules
import { Maximize } from "react-feather";
import { connect } from "react-redux";
import Token from "api/Auth/auth";
import { setMgToken, setHcToken } from "store/Auth";
import store from "store.js";
import { getDetailsAction } from "store/JobList";
import {withRouter} from "react-router"
SwiperCore.use([Pagination, Navigation]);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobdetails:''
    };
  }
  async componentDidMount() {
    // let id = this.props.match.params.id;
    let id = this.props.id
    let HcToken = await Token.getToken();
    store.dispatch(setHcToken(HcToken));
    let MgToken = await Token.getTokenMagitt();
    store.dispatch(setMgToken(MgToken));
    let response = await this.props.getdetailsaction(id);
    // console.log(response.Data[0])
    this.setState({jobdetails:response.Data[0]})

  }
  render() {
    return (
      <>
        <div>
          <div className='flex mb-12'>
            <div className='w-1/2'>
              <Swiper
                spaceBetween={15}
                loop={true}
                loopFillGroupWithBlank={true}
                pagination={{
                  clickable: true,
                }}
                navigation={false}
                className='mySwiper  '
              >
                <SwiperSlide className='relative p-2 block'>
                  <img src={banner1} alt='banner' className='rounded-12px' />
                  <div className='absolute top-0 flex justify-center items-center h-full w-full'>
                    <img
                      src={playbutton}
                      alt='banner'
                      className='w-auto h-auto maxh-329px'
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide className='p-2 block'>
                  <img
                    src={banner1}
                    alt='banner'
                    className='rounded-12px  maxh-329px'
                  />
                  <div className='absolute top-0 flex justify-center items-center h-full w-full'>
                    <img
                      src={playbutton}
                      alt='playbutton'
                      className='w-auto h-auto maxh-329px'
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
            <div className='w-1/2 px-14'>
              <h1 className='text262626 fsize28 font-bold'>
                Business Loans Group
              </h1>
              <p className='fsize18 text4B4B4B pt-2 w-11/12	'>
                We constantly innovate and service over{" "}
              </p>

              <div className='mt-8'>
                <div className='flex mb-6'>
                  <div className='mt-2 w-1/12	'>
                    <img src={check} alt='check' />
                  </div>

                  <p className='text4B4B4B fsize18 line-h30  w-11/12	'>
                    Through our wide distribution of branches across the
                    country, our team of dedicated Relationship Managers{" "}
                  </p>
                </div>

                <div className='flex mb-6'>
                  <div className='mt-2 w-1/12	'>
                    <img src={check} alt='check' />
                  </div>

                  <p className='text4B4B4B fsize18 line-h30  w-11/12	'>
                    Our processes have one of the lowest turnaround times
                    amongst competition.
                  </p>
                </div>

                <div className='flex mb-6'>
                  <div className='mt-2 w-1/12	'>
                    <img src={check} alt='check' />
                  </div>

                  <p className='text4B4B4B fsize18 line-h30  w-11/12	'>
                    We have a superior edge in use of technology & digital to
                    help customers transact with ease
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className='flex'>
            <div className='w-1/2 px-14'>
              <h1 className='text262626 fsize28 font-bold'>
                Business Loans Group
              </h1>
              <p className='fsize18 text4B4B4B pt-2 w-11/12	'>
                We constantly innovate and service over{" "}
              </p>

              <div className='mt-8'>
                <div className='flex mb-6'>
                  <div className='mt-2 w-1/12	'>
                    <img src={check} alt='check' />
                  </div>

                  <p className='text4B4B4B fsize18 line-h30  w-11/12	'>
                    Through our wide distribution of branches across the
                    country, our team of dedicated Relationship Managers{" "}
                  </p>
                </div>

                <div className='flex mb-6'>
                  <div className='mt-2 w-1/12	'>
                    <img src={check} alt='check' />
                  </div>

                  <p className='text4B4B4B fsize18 line-h30  w-11/12	'>
                    Our processes have one of the lowest turnaround times
                    amongst competition.
                  </p>
                </div>

                <div className='flex mb-6'>
                  <div className='mt-2 w-1/12	'>
                    <img src={check} alt='check' />
                  </div>

                  <p className='text4B4B4B fsize18 line-h30  w-11/12	'>
                    We have a superior edge in use of technology & digital to
                    help customers transact with ease
                  </p>
                </div>
              </div>
            </div>
            <div className='w-1/2'>
              <Swiper
                spaceBetween={15}
                loop={true}
                loopFillGroupWithBlank={true}
                pagination={{
                  clickable: true,
                }}
                navigation={false}
                className='mySwiper  '
              >
                <SwiperSlide className='relative p-2 block'>
                  <div className='img__whatnews '>
                    <div className='relative'>
                      <img
                        src={banner2}
                        alt='banner'
                        className='rounded-12px maxh-329px'
                      />
                    </div>

                    <div className='flex img__whatnews_layer justify-center items-center rounded-12px'>
                      <div className=' text-center w-80per'>
                        <div className='flex justify-center items-center'>
                          <p className='text-white font-semibold ml-2  fsize18'>
                            View Fullscreen
                          </p>
                          <Maximize className='text-white ml-4' />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className='p-2 block'>
                  <img
                    src={banner2}
                    alt='banner'
                    className='rounded-12px maxh-329px'
                  />
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    
    getdetails: state.DETAILS.details.JOBDETAILS,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getdetailsaction: async (id) => await dispatch(getDetailsAction(id)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
